export const iconFontAwesomeTextformattingHighlighter = (
	<i className="fa-solid fa-highlighter"></i>
);
